import React from 'react';
import { IFormValue, IProps, IState } from './types';
import { Formik, Form, Field, ErrorMessage, FormikProps, FieldArray } from 'formik';
import { RouterSettings } from 'constants/models/routerSettings';
import { Inscat } from 'bff/models/info';
import service from 'bff/services/memberCorrectionService';
import _ from 'lodash';
import { InsType } from 'constants/enums/insType.enum';
import { ClaimPolicyNoContent, EndorseOptContent, EndorseOptContentData } from 'bff/models/member';
import CorrectionEndorseItem from '../CorrectionEndorseItem';
import { EndorseOption } from 'constants/models/endorseOption';
import * as Yup from 'yup';
import { EndorseType } from 'constants/enums/endorseType';
import { EndorseAttachmentType } from 'constants/enums/endorseAttachmentType';
import FormikFocusError from 'components/FormikFocusError';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
// import moment from 'moment';
import moment from 'moment-timezone';
import InsTypeDefines from 'constants/models/insTypeDefines';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';

let formInitialValues: IFormValue = {
  INS_TYPE: InsType.Travel,
  POLICY_NUMBER: '',
  APPLY_NO: '',
  SDATE: '',
  EDATE: '',
  ENDORSE_OPTS: new Array(0),
  ORIGINAL_ENDORSE: {
    OPTION: new Array(0),
    FILES: new Array(0)
  }
};

const formValidationSchema = Yup.object().shape({
  INS_TYPE: Yup.string().required('此為必填欄位'),
  POLICY_NUMBER: Yup.string().required('此為必填欄位'),
  ENDORSE_OPTS: Yup.array().of(
    Yup.object().shape({
      FILE_FIELD_NAME: Yup.string().test('required', '此為必填欄位', function (val) {
        const { CHECKED, ATTACHMENT } = this.parent;
        if (CHECKED && ATTACHMENT === EndorseAttachmentType.Required) {
          return val;
        }

        return true;
      }),
      FLICHT_INFOS: Yup.array().when('CHECKED', (checked: any, schema: any) => {
        return !checked ? schema : schema.of(Yup.object().shape({
          FDATE: Yup.string().nullable().test('has error', '檢核錯誤', function (val) {
            const { path } = this;
            let errMsg = '';

            if (!val) {
              errMsg = '此為必填欄位';
            }

            return errMsg ? this.createError({ path, message: errMsg }) : true;
          }),
          CARRIER_ID: Yup.string().required('此為必填欄位'),
          FLIGHT_NO: Yup.string().required('此為必填欄位'),
          SEARCH_RESULT: Yup.array().test('has error', '檢核錯誤', function (val) {
            const { path, parent } = this;
            const { FDATE, CARRIER_ID, FLIGHT_NO } = parent;

            if (!FDATE || !CARRIER_ID || !FLIGHT_NO) return true;

            let errMsg = '';

            if (val && val.length <= 0) {
              errMsg = '請查詢航班';
            }

            if (!errMsg && val && val.length > 0 && _.every(val, (valContent: any) => !valContent.CHECKED)) {
              errMsg = '請選擇航班時間及時段';
            }

            return errMsg ? this.createError({ path, message: errMsg }) : true;
          })
        }));
      })
    })
  )
});

const initState: IState = {
  insType: '',
  applyNo: '',
  policyInfos: new Array(0),
  insCats: new Array(0),
  endorse: {
    OPTION: new Array(0),
    FILES: new Array(0)
  },
  UICodes: new Array(0)
};

class CorrectionTravel extends React.Component<IProps, IState> {
  private formikRef = React.createRef<FormikProps<IFormValue>>();
  state: IState = initState;

  componentDidMount = async () => {
    const tempVal = storageService.getItem(storageKeys.CorrectionFormVal);
    if (tempVal) {
      const formVal = JSON.parse(tempVal) as IFormValue;

      const fetchPolicyNosreq = {
        INS_TYPE_ID: formVal.INS_TYPE,
        APPLICANT_ID: storageService.getItem(storageKeys.MemberId)
      };

      const initSetting = await service.fetchTravelInitSetting(fetchPolicyNosreq);
      if (!initSetting) return;
      const endorse = await service.fetchEndorse(formVal.INS_TYPE, formVal.APPLY_NO);
      if (!endorse) return;

      formInitialValues = {
        ...formInitialValues,
        ...formVal
      };

      this.setState({
        insType: formVal.INS_TYPE,
        applyNo: formVal.APPLY_NO,
        policyInfos: [...initSetting.policyInfos],
        UICodes: [...initSetting.UICodes],
        insCats: [...initSetting.inscats]
      });

      return;
    }

    let insTypeIdVal: any;
    let policyNoVal: any;
    let applyNoVal: any;
    if (this.props.history.location.state) {
      // 透過路由取得險種類別
      const { insTypeId, policyNo, applyNo }: any = this.props.history.location.state;
      insTypeIdVal = insTypeId;
      policyNoVal = policyNo;
      applyNoVal = applyNo;
    }

    if (!insTypeIdVal || !policyNoVal) {
      this.props.history.replace(RouterSettings.MemberCenter.PolicyInquiry);
      return;
    }

    const fetchPolicyNosreq = {
      INS_TYPE_ID: insTypeIdVal,
      APPLICANT_ID: storageService.getItem(storageKeys.MemberId)
    };
    const initSetting = await service.fetchTravelInitSetting(fetchPolicyNosreq);
    if (!initSetting) return;
    const endorse = await service.fetchEndorse(insTypeIdVal, applyNoVal);
    if (!endorse) return;

    const policyInfo = _.find(initSetting.policyInfos, (policyInfo: ClaimPolicyNoContent) => policyInfo.APPLY_NO === applyNoVal);
    if (policyInfo) {
      formInitialValues = {
        ...formInitialValues,
        SDATE: policyInfo.SDATE,
        EDATE: policyInfo.EDATE
      };
    }

    formInitialValues = {
      ...formInitialValues,
      INS_TYPE: insTypeIdVal,
      POLICY_NUMBER: policyInfo ? policyInfo.POLICY_NO : '',
      APPLY_NO: applyNoVal,
      ENDORSE_OPTS: this.handleGetEndorseOpts(endorse.OPTION),
      ORIGINAL_ENDORSE: endorse
    };

    this.setState({
      insType: insTypeIdVal,
      applyNo: applyNoVal,
      policyInfos: [...initSetting.policyInfos],
      UICodes: [...initSetting.UICodes],
      insCats: [...initSetting.inscats]
    });
  }

  componentWillUnmount () {
    if (this.props.history.location &&
      this.props.history.location.pathname &&
      this.props.history.location.pathname !== RouterSettings.MemberCenter.CorrectionPreview) {
      storageService.removeItem(storageKeys.CorrectionFormVal);
    }
  }

  /**
 * @description 保單號碼變更事件
 */
  handlePolicyNoChange = async (val: string, setFieldValue: any) => {
    if (!val) return;

    // 取得保單資訊
    const policyInfo = _.find(this.state.policyInfos, (policyInfo: ClaimPolicyNoContent) => policyInfo.POLICY_NO === val);
    if (!policyInfo) return;

    // 取得可變更項目
    const endorse = await service.fetchEndorse(this.state.insType, policyInfo.APPLY_NO);
    if (!endorse) return;

    const endorseOpts = this.handleGetEndorseOpts(endorse.OPTION);

    setFieldValue('APPLY_NO', policyInfo.APPLY_NO);
    setFieldValue('SDATE', policyInfo.SDATE);
    setFieldValue('EDATE', policyInfo.EDATE);
    setFieldValue('ORIGINAL_ENDORSE', endorse);
    setFieldValue('ENDORSE_OPTS', endorseOpts);
  }

  /**
* @description 取得可變更項目(包含預設值)
*/
  handleGetEndorseOpts = (opts: EndorseOptContent[]) => {
    return _.map(opts, (opt: EndorseOptContent) => {
      return {
        CHECKED: false,
        ENDORSE_TYPE: opt.ENDORSE_TYPE,
        DATA_TYPE: opt.DATA_TYPE,
        ORDER_NO: opt.ORDER_NO,
        TYPE_NAME: opt.TYPE_NAME,
        ATTACHMENT: opt.ATTACHMENT,
        ATTACHMENT_NOTE: opt.ATTACHMENT_NOTE,
        ATTACHMENT_NAME: opt.ATTACHMENT_NAME,
        FILE_FIELD_NAME: '',
        FILE_BASE64: '',
        FLICHT_INFOS: this.handleGetFlightInfos(opt.DATA)
      };
    });
  };

  /**
  * @description 取得航班資訊
  */
  handleGetFlightInfos = (flightDatas: EndorseOptContentData[]) => {
    if (!flightDatas || flightDatas.length === 0) return [];

    return _.map(flightDatas, (flightData: EndorseOptContentData) => {
      return {
        FDATE: flightData.FLIGHT_DATE,
        CARRIER_ID: flightData.AIRLINE_ID,
        FLIGHT_NO: flightData.FLIGHT_NO,
        SEARCH_RESULT: [{
          CHECKED: true,
          AIRLINE_ID: flightData.AIRLINE_ID,
          ARRIVAL_AIRPORT: flightData.ARRIVAL_AIRPORT,
          ARRIVAL_TIME: flightData.ARRIVAL_TIME,
          DEPARTURE_AIRPORT: flightData.DEPARTURE_AIRPORT,
          DEPARTURE_TIME: flightData.DEPARTURE_TIME,
          FLIGHT_NO: flightData.FLIGHT_NO,
          FLIGHT_SEGMENT: flightData.FLIGHT_SEGMENT
        }]
      };
    });
  }

  render () {
    /**
       * @description 取得保單號碼選單
       */
    const handleGetPolicyNoOpts = () => {
      if (!this.state.policyInfos || this.state.policyInfos.length === 0) return;

      return _.map(this.state.policyInfos, (policyInfo: ClaimPolicyNoContent, index: number) => {
        if (!policyInfo.POLICY_NO) return;

        return <option value={policyInfo.POLICY_NO} key={index}>{policyInfo.POLICY_NO}</option>;
      });
    };

    /**
     * @description submit 事件
     */
    const handleSubmit = (val: IFormValue) => {
      const endorse = _.find(val.ENDORSE_OPTS, (endorse: any) => endorse.ENDORSE_TYPE === EndorseType.FLIGHT_INFORMATION);
      if (endorse && endorse.CHECKED && endorse.FLICHT_INFOS && endorse.FLICHT_INFOS.length === 0) {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: '請新增航班資訊'
        });
        return;
      }

      storageService.setItem(storageKeys.CorrectionFormVal, JSON.stringify(val));

      const path = {
        pathname: RouterSettings.MemberCenter.CorrectionPreview,
        state: { correctionFormVal: val }
      };

      this.props.history.push(path);
    };

    return (
      <div className="correction">
        <div className="template-container">
          <div className="template-content">
            <div className="correction__title">批改申請</div>
            <div className="correction__content">
              <Formik
                innerRef={this.formikRef as any}
                initialValues={formInitialValues}
                onSubmit={handleSubmit}
                enableReinitialize
                validationSchema={formValidationSchema}
              >
                {({ values, errors, touched, setFieldValue, setFieldTouched, setFieldError, handleChange, handleBlur }) => (
                  <Form>
                    <div className="correction__form">
                      <div className="element__form-table">
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            {/* 險種 */}
                            <div className="element__form-group">
                              <div className="element__form-group-title" data-fieldname="INS_TYPE">險種</div>
                              <div className="element__form-group-content">
                                {
                                  this.state.insCats && this.state.insCats.length > 0 && (
                                    _.map(this.state.insCats, (inscat: Inscat, index: number) => {
                                      if (inscat.INS_TYPE_ID === InsType.MobileDevice) return;
                                      return (
                                        <div className="element__radio-group" key={index}>
                                          <label>
                                            <div className="element__radio">
                                              <Field
                                                type="radio"
                                                disabled
                                                name="INS_TYPE"
                                                value={inscat.INS_TYPE_ID}
                                              />
                                              <div className="element__radio-btn" />
                                            </div>
                                            <span>{inscat.INS_TYPE_NAME}</span>
                                          </label>
                                        </div>
                                      );
                                    })
                                  )
                                }
                              </div>
                              <div className="element__error-message">
                                <ErrorMessage name="INS_TYPE" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            <div className="element__form-group correction__form__info-container">
                              <div className="element__form-group-content correction__form__info-content">
                                <div className="correction__form__info-content-group">
                                  <p>險種</p>
                                  <p>{InsTypeDefines[this.state.insType as InsType]}</p>
                                </div>
                                <div className="correction__form__info-content-group">
                                  <p>保單號碼*</p>
                                  <Field
                                    as="select"
                                    name="POLICY_NUMBER"
                                    id="policy-number-input"
                                    className="element__select"
                                    data-fieldname="POLICY_NUMBER"
                                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                      this.handlePolicyNoChange(e.currentTarget.value, setFieldValue);
                                      handleChange(e);
                                    }}
                                  >
                                    <option value="">請選擇</option>
                                    {
                                      handleGetPolicyNoOpts()
                                    }
                                  </Field>
                                  <div className="element__error-message">
                                    <ErrorMessage name="POLICY_NUMBER" />
                                  </div>
                                </div>
                                <div className="correction__form__info-content-group">
                                  <p>保險期間</p>
                                  <p>
                                    {
                                      `${moment(values.SDATE).isValid() && moment(values.SDATE).format('YYYY/MM/DD-HH:mm')}-
                                ${moment(values.EDATE).isValid() && moment(values.EDATE).format('YYYY/MM/DD-HH:mm')}`
                                    }
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            {/* 變更項目 */}
                            <div className="element__form-group">
                              <div className="element__form-group-title" data-fieldname="ENDORSE_OPTS">變更項目</div>
                              <div className="element__form-group-content">
                                <div className="correction__list">
                                  {/* 變更航班資訊 */}
                                  <FieldArray name="ENDORSE_OPTS">
                                    {
                                      () => (
                                        <>
                                          {
                                            values.ENDORSE_OPTS && values.ENDORSE_OPTS.length > 0 && (
                                              _.map(values.ENDORSE_OPTS, (opt: EndorseOption, index: number) => {
                                                return (
                                                  <CorrectionEndorseItem
                                                    insTypeId={this.state.insType}
                                                    endorseOpt={opt}
                                                    endorseOptIndex={index}
                                                    key={index}
                                                    values={values}
                                                    errors={errors}
                                                    touched={touched}
                                                    setFieldValue={setFieldValue}
                                                    setFieldTouched={setFieldTouched}
                                                    setFieldError={setFieldError}
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    postCodes={[]}
                                                    emailDomains={[]}
                                                    rdStDataContent={[]}
                                                    mortgageBanks={[]}
                                                    yesnoSysOpts={[]}
                                                    marriageSysOpts={[]}
                                                    UICodes={this.state.UICodes}
                                                  />
                                                );
                                              })
                                            )
                                          }
                                        </>
                                      )
                                    }
                                  </FieldArray>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="correction__controls">
                      <button type="submit" className="element__button element__button--red">預覽畫面</button>
                      <button
                        type="button"
                        className="element__button element__button--red-border"
                        onClick={() => {
                          this.props.history.replace(RouterSettings.MemberCenter.PolicyInquiry);
                        }}
                      >
                        取消
                      </button>
                    </div>
                    <FormikFocusError />
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CorrectionTravel;
